<!-- Componente de CRUD para Templates de IA -->

<template>
  <CTabs variant="tabs" class="nav-tabs-boxed">
    <CTab title="Templates de IA">
      <crud-base
        :url="url"
        :columns="columns"
        :onDelete="() => {}"
        :onUpdate="() => {}"
        :onStore="() => {}"
        :enableSearch="true"
        :checkAlerts="true"
        primaryKey="id"
      />
    </CTab>
  </CTabs>
</template>

<script>
import CrudBase from "../../components/crud/CrudBase";
export default {
  name: "templates-ia",
  components: {
    CrudBase,
  },
  data() {
    return {
      url: "/admin/template-resumo-ia",
      columns: [
        { label: "Id", field: "id", sortable: false },
        { label: "Nome", field: "nome", sortable: false },
        { label: "Tipo", field: "tipo", sortable: false },
      ],
    };
  },
};
</script>
